[
  {
    "id": "SR-E6-PV-LOOPT-V01",
    "module": "SpellingRegel",
    "difficulty": 105,
    "difficultyTier": 5,
    "levelCode": "E6",
    "group": 6,
    "skill": "zinsontleding",
    "subSkill": "persoonsvorm",
    "familyId": "SR-PERSOONSVORM-VINDEN",
    "conceptId": "find_finite_verb",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Wat is de persoonsvorm in deze zin: \"De oude man loopt langzaam naar de overkant.\"",
    "options": ["loopt", "man", "de oude man", "langzaam"],
    "correctAnswer": 0,
    "explanation": "Maak de zin vragend: 'Loopt de oude man...?' Het werkwoord dat vooraan komt, is de persoonsvorm. 'Loopt' verandert als je de tijd verandert (liep), dus het is de persoonsvorm.",
    "distractorExplanations": {
      "1": "'Man' is een zelfstandig naamwoord, geen werkwoord.",
      "2": "'De oude man' is het onderwerp (wie loopt er?), niet de persoonsvorm.",
      "3": "'Langzaam' is een bijwoord — het zegt iets over hoe hij loopt."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Persoonsvorm Vinden",
        "content": "Maak de zin vragend. Het werkwoord dat vooraan komt, is de persoonsvorm. 'Loopt de man?' → loopt",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "SR-E6-VD-BEZEERD-V01",
    "module": "SpellingRegel",
    "difficulty": 105,
    "difficultyTier": 5,
    "levelCode": "E6",
    "group": 6,
    "skill": "klanken_spelling",
    "subSkill": "eind_d_t",
    "familyId": "SR-VOLTOOID-DEELWOORD-DT",
    "conceptId": "past_participle_d_or_t",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: De hond heeft zijn poot .....",
    "options": ["bezeerd", "bezeerts", "bezeerdte", "bezeerdt"],
    "correctAnswer": 0,
    "explanation": "Voltooid deelwoord van 'bezeren'. Stam = bezeer. De 'r' zit NIET in 't kofschip, dus eindigt het op '-d': bezeerd.",
    "distractorExplanations": {
      "1": "Een voltooid deelwoord eindigt op '-d' of '-t', nooit op '-ts'.",
      "2": "Dit is een mix van verleden tijd en voltooid deelwoord. Het is gewoon 'bezeerd'.",
      "3": "'-dt' komt niet voor aan het eind van een voltooid deelwoord."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Voltooid Deelwoord: d of t?",
        "content": "Stam eindigt NIET op een letter uit 't kofschip? → eindigt op -d. Bezeer → bezeerd.",
        "icon": "book"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "SR-E6-TREMA-IDEEEN-V01",
    "module": "SpellingRegel",
    "difficulty": 105,
    "difficultyTier": 5,
    "levelCode": "E6",
    "group": 6,
    "skill": "schrijfwijze",
    "subSkill": "trema",
    "familyId": "SR-TREMA-MEERVOUD",
    "conceptId": "trema_plural_vowel_collision",
    "variantIndex": 3,
    "questionType": "multiple_choice",
    "question": "Welk woord is correct gespeld (trema)?",
    "options": ["ideeën", "ideeen", "idëeen", "ideeien"],
    "correctAnswer": 0,
    "explanation": "Meervoud van 'idee' is 'ideeën'. Het trema staat op de derde 'e' zodat je weet dat het i-dee-en is (drie lettergrepen).",
    "distractorExplanations": {
      "1": "Zonder trema is de uitspraak onduidelijk. Je zou 'ie-deen' kunnen lezen.",
      "2": "Het trema staat op de verkeerde 'e'. Het hoort op de derde: ideeën.",
      "3": "Er komt geen 'i' tussen. Het is idee + en = ideeën."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Trema Regel",
        "content": "Een trema (¨) laat zien dat klinkers apart uitgesproken worden: idee + en → ideeën",
        "icon": "book"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "SR-E6-EAU-COMBI-V01",
    "module": "SpellingRegel",
    "difficulty": 105,
    "difficultyTier": 5,
    "levelCode": "E6",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_eau",
    "familyId": "SR-WEETWOORD-EAU-COMBI",
    "conceptId": "french_eau_combination",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welke woorden zijn allebei goed gespeld?",
    "options": ["cadeau en bureau", "cado en buro", "kadeau en bureau", "cadeau en buro"],
    "correctAnswer": 0,
    "explanation": "'Cadeau' en 'bureau' zijn beide correct met '-eau'. Dit zijn Franse leenwoorden.",
    "distractorExplanations": {
      "1": "'Cado' en 'buro' zijn spreektaal, niet de standaardspelling.",
      "2": "'Kadeau' met 'k' is fout. Het begint met 'c'.",
      "3": "'Buro' is spreektaal. Het moet 'bureau' zijn."
    }
  },
  {
    "id": "SR-E6-EAU-INVULLEN-V01",
    "module": "SpellingRegel",
    "difficulty": 105,
    "difficultyTier": 5,
    "levelCode": "E6",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_eau",
    "familyId": "SR-WEETWOORD-EAU-COMBI",
    "conceptId": "french_eau_combination",
    "variantIndex": 2,
    "questionType": "multiple_choice",
    "question": "Vul in: Op mijn bur... ligt een cad... van mijn vriend.",
    "options": ["bureau, cadeau", "buro, cado", "bureau, cado", "buro, cadeau"],
    "correctAnswer": 0,
    "explanation": "Beide woorden zijn Franse leenwoorden met '-eau': bureau en cadeau.",
    "distractorExplanations": {
      "1": "'Buro' en 'cado' zijn spreektaal, niet de standaardspelling.",
      "2": "'Bureau' is goed, maar 'cado' is spreektaal. Beide moeten '-eau' hebben.",
      "3": "'Buro' is spreektaal. 'Cadeau' is goed, maar beide moeten correct zijn."
    }
  }
]